import { useState, useEffect, useRef } from "react";
import styles from "./EventTitle.module.scss";
import { EventTitleProps } from "../../../../types/props";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import EditIcon from "../../image/edit.svg";
import undo from "../../image/undo.svg";
import { useWidth } from "../../../../hooks/useWidth";

export const EventTitle = ({ id, title, tickets, btnType, blockButton }: EventTitleProps) => {
    const titleRef = useRef<HTMLHeadingElement>(null);
    const priceRef = useRef<HTMLHeadingElement>(null);
    const [totalWidth, setTotalWidth] = useState(0);
    const navigate = useNavigate();
    const isMobile = useIsMobile();
    const width = useWidth();

    const getElementsWidth = () => {
        if (titleRef.current && priceRef.current) {
            setTotalWidth(titleRef.current.offsetWidth + priceRef.current.offsetWidth);
        }
    };

    let minPrice = Infinity;
    let maxPrice = -Infinity;

    tickets.forEach((ticket) => {
        if (minPrice > ticket.price) {
            minPrice = ticket.price;
        }
        if (maxPrice < ticket.price) {
            maxPrice = ticket.price;
        }
    });

    const minPriceStr = minPrice.toLocaleString();
    const maxPriceStr = maxPrice.toLocaleString();

    let formattedPrice: string;
    if (minPrice === maxPrice) {
        formattedPrice = `${minPriceStr} ₽`;
    } else if (minPrice === 0) {
        formattedPrice = "Бесплатно";
    } else {
        formattedPrice = `${minPriceStr} ₽ - ${maxPriceStr} ₽`;
    }

    const handleEdit = () => {
        navigate(`/edit_event/${id}`);
    };

    const handleBack = () => {
        navigate(`/organizer_event/${id}`);
    };

    useEffect(() => {
        getElementsWidth();
    }, []);

    const isMobileView = isMobile || width < 1066 || (width < 1200 && totalWidth > 360);

    return isMobileView ? (
        <div className={styles.topWrapper + " " + styles.mobileView}>
            <div className={styles.titleWrapper}>
                <h1 ref={titleRef} className={styles.title}>{title}</h1>
                {btnType === "back" && (
                    <button className={styles.btnOutline} onClick={handleBack}>
                        <img src={undo} alt="undo" />
                    </button>
                )}
                {btnType === "edit" && (
                    <button className={styles.btnOutline} onClick={handleEdit} disabled={blockButton}>
                        {width < 1024 ? <img src={EditIcon} alt="Иконка редактирования" /> : "Редактировать"}
                    </button>
                )}
            </div>
            <h2 ref={priceRef} className={styles.price}>{formattedPrice}</h2>
            {btnType === "back" && (
                <div className={styles.eventCode}>Код события: 007</div>
            )}
        </div>
    ) : (
        <div className={styles.topWrapper}>
            <div className={styles.titleWrapper}>
                <h1 ref={titleRef} className={styles.title}>{title}</h1>
                <h2 ref={priceRef} className={styles.price}>{formattedPrice}</h2>
            </div>
            <button className={styles.btnOutline}
                    onClick={handleEdit}
                    disabled={blockButton}>
                <span>Редактировать</span>
            </button>
        </div>
    );
};
